import { useMsal } from '@azure/msal-react';
import { getAuthService } from 'services/login/msalService';

/**
 * Custom hook for handling authentication
 */
export const useMsalAuth = () => {
  const { instance } = useMsal();
  const authService = getAuthService(instance);

  return {
    loginPopup: () => authService.loginPopup(),
    loginRedirect: () => authService.loginRedirect(),
    logout: () => authService.logout(),
    getAccessToken: (scopes: string[]) => authService.getAccessToken(scopes),
    isAuthenticated: () => authService.isAuthenticated(),
    getUserInfo: () => authService.getAccount()
  };
};
